import { css } from 'styled-components';
import { responsiveProperty } from './responsiveProperty';
export const marginPropsNames = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my'];
export const marginProps = css `
  ${(props) => props.m && responsiveProperty('margin', props.m)};
  ${(props) => props.mt && responsiveProperty('marginTop', props.mt)};
  ${(props) => props.mr && responsiveProperty('marginRight', props.mr)};
  ${(props) => props.mb && responsiveProperty('marginBottom', props.mb)};
  ${(props) => props.ml && responsiveProperty('marginLeft', props.ml)};

  ${(props) => props.mx && responsiveProperty('marginLeft', props.mx)};
  ${(props) => props.mx && responsiveProperty('marginRight', props.mx)};

  ${(props) => props.my && responsiveProperty('marginTop', props.my)};
  ${(props) => props.my && responsiveProperty('marginBottom', props.my)};
`;
